<template>
  <div
    class="logo"
    :class="{ 'logo-collapsed': !isSidebarOpened }"
  >
    <div class="logo__icon" />
    <div
      v-show="isSidebarOpened"
      class="logo__opened"
    >
      <div class="logo__full" />
      <div
        class="logo__label"
        :class="{ 'logo__label--loading': !shopName }"
      >
        <a
          class="logo__shop-name"
          :href="sellerPageAbsoluteUrl"
          target="_blank"
        >
          {{ $t("common.seller") }}
          <template v-if="shopName">
            {{ shopName }}
          </template>
          <a-icon
            v-else
            type="loading"
          />
        </a>
        <span
          v-if="shopName"
          class="logo__outer-link-icon"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"

export default {
  name: "DashboardSidebarLogo",
  props: {
    isSidebarOpened: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapState("user", {
      profile: (state) => state.profile || {}
    }),
    shopName() {
      return this.profile.name || ""
    },
    sellerPageAbsoluteUrl() {
      return `${process.env.VUE_APP_MARKETPLACE_URL}/seller/${this.profile.slug}`
    }
  }
}
</script>

<style lang="scss" scoped>
$logo-icon-width: 24px;
$logo-icon-height: 30px;
$logo-full-width: 96px;
$logo-full-height: 12px;

.logo {
  height: $header-height;
  border-bottom: 1px solid $sider-border-color;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
  padding: 0 16px 0 24px;

  &-collapsed {
    justify-content: center;
    padding: 0;
  }

  &__opened {
    display: flex;
    flex-direction: column;
    margin-left: 8px;
    width: calc(100% - 38px);
  }

  &__icon {
    display: inline-flex;
    flex-basis: $logo-icon-width;
    min-width: $logo-icon-width;
    min-height: $logo-icon-height;
    width: $logo-icon-width;
    height: $logo-icon-height;
    background: url("../../assets/icons/logo-icon.svg"), no-repeat;
  }

  &__outer-link-icon {
    width: 12px;
    height: 12px;
    min-width: 12px;
    min-height: 12px;
    margin-left: 8px;
    display: inline-block;
    background: url("../../assets/icons/outer-link.svg"), no-repeat;
  }

  &__label {
    display: inline-flex;
    align-items: baseline;
    max-width: 100%;
    cursor: pointer;
    line-height: $base-line-height;
    height: $base-line-height;

    &:hover {
      text-decoration: underline;
    }

    &--loading {
      cursor: default;
      pointer-events: none;

      &:hover {
        text-decoration: none;
      }
    }
  }

  &__full {
    display: inline-flex;
    min-width: $logo-full-width;
    min-height: $logo-full-height;
    width: $logo-full-width;
    height: $logo-full-height;
    flex-basis: $logo-full-height;
    background: url("../../assets/icons/logo-full.svg"), no-repeat;
    margin-bottom: 4px;
  }

  &__shop-name {
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(100%);
    color: #9eaebe;
  }
}
</style>
